import React, { useState } from 'react';
import { API_BASE_URL } from "../config";
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import './SignIn.css';

const SignIn = ({ onSuccessfulLogin }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [mode, setMode] = useState("login");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      console.log(`Attempting to ${mode} with:`, formData.email);
      const response = await fetch(`${API_BASE_URL}/${mode}`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
          email: formData.email,
          password: formData.password
        })
      });

      console.log('Response status:', response.status);
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Login response:', data);
      
      if (data.status === "success") {
        console.log("✅ Login successful, saving user data");
        const userData = {
          email: formData.email,
          isAuthenticated: true,
          is_admin: data.is_admin || false
        };

        if (formData.rememberMe) {
          localStorage.setItem("rememberedEmail", formData.email);
        } else {
          localStorage.removeItem("rememberedEmail");
        }

        if (typeof onSuccessfulLogin === 'function') {
          onSuccessfulLogin(userData);
        } else {
          localStorage.setItem("user", JSON.stringify(userData));
        }
      } else {
        throw new Error(data.message || "Authentication failed");
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || "Failed to connect to the server. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSuccess = (credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      console.log("Google Login Success:", decoded);
      
      const userData = {
        email: decoded.email,
        name: decoded.name,
        picture: decoded.picture,
        isAuthenticated: true,
        is_admin: false, // You might need to verify admin status via your backend in production
        isGoogleAuth: true
      };

      localStorage.setItem("user", JSON.stringify(userData));
      
      if (typeof onSuccessfulLogin === 'function') {
        onSuccessfulLogin(userData);
      }
    } catch (err) {
      console.error("Failed to decode Google JWT", err);
      setError("Google Login failed. Please try again.");
    }
  };

  const handleGoogleError = () => {
    console.error("Google Login Failed");
    setError("Google Login failed. Please try again.");
  };

  return (
    <div className="signin-container">
      <div className="signin-left">
        <h1>Turn your ideas into reality.</h1>
        <p>Start for free and get attractive offers from the community</p>
      </div>

      <div className="signin-right">
        <GoogleOAuthProvider clientId="YOUR_GOOGLE_CLIENT_ID">
          <div className="form-container">
          <h2>{mode === "login" ? "Sign In to your Account" : "Create a New Account"}</h2>

          <form onSubmit={handleSubmit} className="signin-form">
            <input
              type="email"
              name="email"
              placeholder="Email address"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
            />

            {mode === "login" && (
              <label>
                <input
                  type="checkbox"
                  name="rememberMe"
                  checked={formData.rememberMe}
                  onChange={handleChange}
                />
                Remember me
              </label>
            )}

            {error && <div className="error-message">{error}</div>}

            <button type="submit" disabled={loading}>
              {loading ? "Processing..." : (mode === "login" ? "Sign In" : "Sign Up")}
            </button>
          </form>

          <div className="signup-link">
            {mode === "login" ? (
              <p>Don't have an account? <a href="#" onClick={(e) => { e.preventDefault(); setMode("signup"); }}>Sign up</a></p>
            ) : (
              <p>Already have an account? <a href="#" onClick={(e) => { e.preventDefault(); setMode("login"); }}>Sign in</a></p>
            )}
          </div>

          <div className="divider">
            <span>OR</span>
          </div>

          <div className="google-login-wrapper">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              theme="filled_black"
              shape="rectangular"
              size="large"
              text="continue_with"
              width="100%"
            />
          </div>
        </div>
        </GoogleOAuthProvider>
      </div>
    </div>
  );
};

export default SignIn;